
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExtraFieldCounterService {

  public extraCount = [];
  refreshExtras = new BehaviorSubject('');
  extrasRefreshed = new BehaviorSubject(false);


  constructor() { }

  saveExtraCount(extraCounter: any) {
    this.extraCount = extraCounter;
  }

  fetchRefreshExtras(section: string) {
    this.refreshExtras.next(section);
  }

  fetchExtrasRefreshed(fetch: boolean) {
    this.extrasRefreshed.next(fetch);
  }

}